module.exports = function getResource(label, vars = []) {
    let resources = {
        foundation: 'Foundation',
        concealer: 'Concealer'
    };
    return resources[label];
};
